import React from 'react';
import c from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, TitleWithText } from '@uncinc/uncinc-react-kitchen-sink';

import { ButtonWrapper, LinkList } from '../../../components';
import type { ParagraphLinkList as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphLinkListProps {
  id?: string;
  entity: ImmutableEntity<Type>;
  isWide?: boolean;
  noBootstrap?: boolean;
}

const ParagraphLinkList: React.FC<ParagraphLinkListProps> = ({
  id,
  entity,
  isWide = false,
  noBootstrap = false,
}) => {
  const paragraphLinkList = entity.toJS();

  const title = paragraphLinkList.field_title?.[0]?.value;
  const body = paragraphLinkList.field_body?.[0]?.processed;
  const link = paragraphLinkList.field_link?.[0];
  const linkUrl = link?.alias ?? link?.uri;
  const linkTitle = link?.title;
  const secondaryLink = paragraphLinkList.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUrl = secondaryLink?.alias || secondaryLink?.uri;
  const items = paragraphLinkList.field_paragraphs;

  const textColClasses = isWide ? 'col-12 col-md-10 col-lg-8' : 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-1';
  const linkListColClasses = isWide ? 'col-12' : 'col-12 col-md-10 offset-md-1';
  const classes = c('Paragraph', 'ParagraphLinkList', {
    'ParagraphLinkList--noBootstrap': noBootstrap,
  });

  return (
    <div id={id} className={classes}>
      <Container>
        <div className={`${noBootstrap ? 'noBootstrapRow' : 'row'} ParagraphLinkList__wrapper`}>
          {(title || body || linkUrl || secondaryLinkUrl) && (
            <div className={noBootstrap ? 'noBootstrapColumn' : textColClasses}>
              <div className="ParagraphLinkList__text-wrapper">
                <TitleWithText
                  className="ParagraphLinkList__text"
                  title={title}
                  text={body}
                />
                {(linkUrl || secondaryLinkUrl) && (
                  <div className="ParagraphLinkList__links">
                    {linkUrl && (
                      <ButtonWrapper
                        type="secondary"
                        href={linkUrl}
                      >
                        {linkTitle}
                      </ButtonWrapper>
                    )}

                    {secondaryLinkUrl && (
                      <ButtonWrapper
                        type="textual"
                        href={secondaryLinkUrl}
                      >
                        {secondaryLinkTitle}
                      </ButtonWrapper>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          <div className={noBootstrap ? 'noBootstrapColumn' : linkListColClasses}>
            <LinkList>
              {items.map((item) => {
                const itemTitle = item.entity.field_title?.[0]?.value;
                const itemLabel = item.entity.field_label?.[0]?.value;
                const itemLink = item.entity.field_link?.[0];
                const itemLinkUrl = itemLink?.alias ?? itemLink?.uri;
                const itemImage = item.entity.field_media_item[0];

                return (
                  <LinkList.Item
                    key={item.target_id}
                    title={itemTitle}
                    label={itemLabel}
                    link={itemLinkUrl}
                    image={itemImage}
                    readMore
                    aspectRatio="16_9"
                  />
                );
              })}
            </LinkList>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphLinkList;
